import { useContext } from "react"
import { DESC } from "helpers/sorts"
import { useFactorViewDashboardMetrics } from "helpers/metrics/hooks"
import { useTemplateGatherers } from "connected-components/dashboard/hooks/use-template-gatherers"
import { CONTENT_SET_DATA_TYPES } from "helpers/contentSetConstants"
import { useAnalytics } from "connected-components/analytics"
import { useFactorsViewTableHandlers } from "../../hooks/use-factors-view-table-handlers"
import ContributorsDataIntegrator from "gatherers/contributors-data-integrator"
import ContributorsTable from "renderers/contributors-datagrid"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { CONTENT_SET_CONTEXT } from "./context"
import { FACTORS_VIEW_COMMON_PROPS } from "../../prop-types"

export default function FactorsContentSetView({ context, instrumentsWithMetadata, instrumentColumns, selectedContentSetMetadata }) {
  const { sortMetricId, setSortMetricId, sortDirection, setSortDirection, selectedTableLevels, setSelectedTableLevels, view: contentSetId, isEndVsStartDateComparison } = useContext(context)
  const { selectedCategory } = useContext(CONTENT_SET_CONTEXT)

  const analytics = useAnalytics()
  const { handleSortChanged, handleTableNavigationChanged } = useFactorsViewTableHandlers({ track: analytics.track })

  const gatherers = useTemplateGatherers(context, "factorContentSet", { contentSetId, useCompositionQueries: false, selectedCategory })

  const metrics = useFactorViewDashboardMetrics(
    [{ category: "factorContentSet", isSensitivity: selectedContentSetMetadata.dataType === CONTENT_SET_DATA_TYPES.SENSITIVITY }],
    { contentSetId, instrumentColumns, instrumentsWithMetadata, isEndVsStartDateComparison },
  )

  const defaultSortSuffix = INSTRUMENTS[instrumentColumns[0]].suffix

  return <ContributorsDataIntegrator
    gatherers={gatherers}
    metrics={metrics}
    Renderer={ContributorsTable}
    rendererProps={{
      groupByName: "Category",
      defaultSort: {
        path: `contentSetNetContribution${defaultSortSuffix}`,
        direction: DESC,
      },
      disableCategories: true,
      classes: "factors-table",
      idLabel: "Factor",
      hidePagination: true,
      includeDrilldownArrows: true,
      downloadKey: "factors.contentSet",
      downloadName: "Factors - Content Set",
      sortMetricId,
      onSortMetricIdChange: setSortMetricId,
      sortDirection,
      onSortDirectionChange: setSortDirection,
      tableNavigationLevels: selectedTableLevels,
      onTableNavigationChange: setSelectedTableLevels,
      onSortChanged: handleSortChanged,
      onTableNavigationChanged: handleTableNavigationChanged,
      context,
    }}
  />
}

FactorsContentSetView.propTypes = FACTORS_VIEW_COMMON_PROPS
